<template lang="pug">
.v-swiper-slider.swiper-slider
	.swiper-slider__wrap(v-if="sliderReady")
		swiper.swiper-slider__slider.scrollable-content(
				:class="swiperClassName"
				:modules="modules"
				:navigation="navigation"
				:pagination="pagination"
				:effect="effect || options.effect"
				:scrollbar="scrollbar"
				:speed="options.speed"
				:autoplay="options.autoplay"
				:initial-slide="options.initialSlide || 0"
				:breakpoints="options.breakpoints || null"
				:slides-per-view="options.slidesPerView || 1"
				:direction="options.direction || 'horizontal'"
				:loop="options.loop || false"
				:space-between="options.spaceBetween || 20"
				:a11y="options.a11y"
				:watch-slides-progress="watchSlidesProgress"
				@swiper="onSwiper"
				@init="onInit"
				:thumbs="thumbs"
				@slide-change="onSlideChange")
			slot
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';
// Swiper docs: https://swiperjs.com/vue
import {Navigation, Pagination, Scrollbar, A11y, EffectFade, Mousewheel, Autoplay} from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/effect-fade';
import 'swiper/css/free-mode';

export default {
	components: {
		Swiper,
		SwiperSlide
	},

	emits: [
		'slide-change',
		'swiper',
		'emit'
	],

	props: {
		options: {
			type: Object,
			default: null
		},

		navigation: {
			type: [Boolean, Object],
			default: false
		},

		pagination: {
			type: Object,
			default: {
				el: null
			}
		},

		scrollbar: {
			type: Object,
			default: {
				el: null
			}
		},

		effect: {
			type: String,
			default: null
		},

		watchSlidesProgress: {
			type: Boolean,
			default: false
		},

		animated: {
			type: Boolean,
			default: false
		},

		swiperClassName: {
			type: String,
			default: null
		},

		thumbs: {
			type: Object,
			default: {}
		}
	},

	data() {
		return {
			sliderReady: false,
			uniqueId: uniqueId('swiper-slider-'),
			swiper: null,
			modules: [
				Navigation,
				Pagination,
				Scrollbar,
				EffectFade,
				Autoplay,
				A11y,
				EffectFade,
				Mousewheel,
				Autoplay
			],
			autoplayTimeout: null
		};
	},

	watch: {
		animated() {
			console.log('animated');
			// if (this.animated) {
			// 	this.autoplayTimeout = setInterval(() => {
			// 		this.swiper.slideNext();
			// 	}, 2000);
			// } else {
			// 	clearInterval(this.autoplayTimeout);
			// }
		}
	},

	mounted() {
		this.sliderReady = true;

		if (this.swiper && this.options.autoplay) {
			this.swiper.update();
			this.swiper.autoplay.start();
		}


		// if (this.animated) {
		// 	this.autoplayTimeout = setInterval(() => {
		// 		this.swiper.slideNext();
		// 	}, 2000);
		// } else {
		// 	clearInterval(this.autoplayTimeout);
		// }
	},

	methods: {
		onInit() {
			this.$emit('emit');
		},

		onSwiper(swiper) {
			this.swiper = swiper;

			if (this.options.autoplay && this.swiper.autoplay) {
				this.swiper.autoplay.start();
			}
			this.$emit('swiper', this.swiper);
		},

		onSlideChange(e) {
			this.$emit('slide-change', e);
		},

		slideTo(index) {
			this.swiper.slideTo(index);
		},

		slideNext() {
			this.swiper.slideNext();
		},

		slidePrev() {
			this.swiper.slidePrev();
		}
	}
};
</script>